import React from "react";
import { FIT_STYLE, FIT_LABEL, classifySeatFit, SPACE_FIT_DEFINITION } from "../services/seatFit.js";
import { useSpacePolicy } from "../services/spacePolicyStore.js";
export function SpaceFitSummary({ assigned, installed, excluded = false, sourceStatus = "ok", partial = false }) {
  const { baseline, status: policyStatus } = useSpacePolicy();
  const status = excluded ? "excluded" : sourceStatus === "error" || policyStatus === "error" ? "error"
    : sourceStatus === "loading" || ["idle", "loading"].includes(policyStatus) ? "loading" : classifySeatFit(assigned, installed, baseline);
  const st = FIT_STYLE[status];
  return <span style={{ display: "inline-flex", alignItems: "center", gap: 4 }}>
    <span title={SPACE_FIT_DEFINITION} style={st ? { background: st.bg, color: st.ink,
      border: `1px solid ${st.border}`, borderRadius: 6, padding: "2px 8px" } : {}}>
      {FIT_LABEL[status] ?? (status === "loading" ? "Loading…" : "Unavailable")}
    </span>
    {partial && <small title="Known office subtotals; coverage is incomplete.">Partial</small>}
  </span>;
}
